<template>

<div class="trade-summary">

	<div class="trade-section">

		<Preloader v-show="!initializationDone" />

		<div v-if="initializationDone">

			<div v-if="loadtimestamp" class="mb-2"><strong>{{ $t('common.noun.time')}}</strong>: {{ timeStamp }}<br /></div>

			<div v-if="loadtokens">


				<!-- ==================================== Begin isMaker ===================================== -->
				<div v-if="isMaker">

					<v-row dense>

						<v-col class="nowrap">
							<ERC20Token :symbol="makerAssetInfo.symbol"
								:name="makerAssetInfo.name"
								:address="makerAssetInfo.address"
								:decimals="makerAssetInfo.decimals"
								:tokenurl="tokenurl" />
							<div class="order-amount-wrapper">{{ $t('common.verb.haveSent')}}: <AmountNumber :value="makerTokenAmount" /></div>
						</v-col>

						<v-col class="nowrap">
								<ERC20Token :symbol="takerAssetInfo.symbol"
									:name="takerAssetInfo.name"
									:address="takerAssetInfo.address"
									:decimals="takerAssetInfo.decimals"
									:tokenurl="tokenurl" />
								<div class="order-amount-wrapper">{{ $t('common.verb.haveReceived')}}: <AmountNumber :value="takerTokenAmount" /></div>
						</v-col>

					</v-row>

					<v-row dense>

						<!-- price taker per maker -->
						<v-col class="nowrap">
							1 {{ takerAssetInfo.symbol }} =
          		<strong>{{ formatAmountNumber(priceTakerPerMaker) }}</strong>
          		{{ makerAssetInfo.symbol }}
						</v-col>

						<!-- price maker per taker -->
						<v-col class="nowrap">
							1 {{ makerAssetInfo.symbol }} =
							<strong>{{ formatAmountNumber(priceMakerPerTaker) }}</strong>
							{{ takerAssetInfo.symbol }}
						</v-col>

					</v-row>

					<v-row dense>

						<!-- maker -->
						<v-col class="nowrap">
							<strong>{{ $t('common.noun.maker') }}</strong>: <UserAddress :address="trade.makerAddress" :myaddress="network.userAccount" :accounturl="networkConfig.accountURL" markself></UserAddress>
						</v-col>

						<!-- taker -->
						<v-col class="nowrap">
							<strong>{{ $t('common.noun.taker') }}</strong>: <UserAddress :address="trade.takerAddress" :myaddress="network.userAccount" :accounturl="networkConfig.accountURL" markself></UserAddress>
						</v-col>
					</v-row>

					<v-row dense>

						<v-col>

							<!-- maker fee -->
							<div>
								<strong>{{ $t('compTradeSummary.exChangeFeeYouPaid') }}</strong>:
								<span v-if="makerFee == 0">0</span>
							</div>
							<ul v-if="makerFee > 0">
								<li>{{ $t('common.noun.makerFee') }}:
									{{ formatAmountNumber(makerFee) }}
									<span v-if="makerFeeAssetInfo">{{ makerFeeAssetInfo.symbol }}</span></li>
							</ul>

						</v-col>

					</v-row>

				</div>
				<!-- ==================================== End isMaker ===================================== -->


				<!-- ==================================== Begin isTaker ===================================== -->
				<div v-if="isTaker">

					<v-row dense>

						<v-col class="nowrap">
							<ERC20Token :symbol="takerAssetInfo.symbol"
								:name="takerAssetInfo.name"
								:address="takerAssetInfo.address"
								:decimals="takerAssetInfo.decimals"
								:tokenurl="tokenurl" />
							<div class="order-amount-wrapper">{{ $t('common.verb.haveSent')}}: <AmountNumber :value="takerTokenAmount" /></div>
						</v-col>

						<v-col class="nowrap">
							<ERC20Token :symbol="makerAssetInfo.symbol"
								:name="makerAssetInfo.name"
								:address="makerAssetInfo.address"
								:decimals="makerAssetInfo.decimals"
								:tokenurl="tokenurl" />
							<div class="order-amount-wrapper">{{ $t('common.verb.haveReceived')}}:  <AmountNumber :value="makerTokenAmount" /></div>
						</v-col>
					</v-row>

					<v-row dense>

						<!-- price taker per maker -->
						<v-col class="nowrap">
							1 {{ takerAssetInfo.symbol }} =
							<strong>{{ formatAmountNumber(priceTakerPerMaker) }}</strong>
							{{ makerAssetInfo.symbol }}
						</v-col>

						<!-- price maker per taker -->
						<v-col class="nowrap">
							1 {{ makerAssetInfo.symbol }} =
							<strong>{{ formatAmountNumber(priceMakerPerTaker) }}</strong>
							{{ takerAssetInfo.symbol }}
						</v-col>

					</v-row>

					<v-row dense>

						<!-- maker -->
						<v-col class="nowrap">
							<strong>{{ $t('common.noun.maker') }}</strong>: <UserAddress :address="trade.makerAddress" :myaddress="network.userAccount" :accounturl="networkConfig.accountURL" markself></UserAddress>
						</v-col>

						<!-- taker -->
						<v-col class="nowrap">
							<strong>{{ $t('common.noun.taker') }}</strong>: <UserAddress :address="trade.takerAddress" :myaddress="network.userAccount" :accounturl="networkConfig.accountURL" markself></UserAddress>
						</v-col>
					</v-row>

					<v-row dense>

						<v-col >

							<!-- taker fee -->
							<div>
								<strong>{{ $t('compTradeSummary.exChangeFeeYouPaid') }}</strong>:
								<span v-if="takerFee == 0 && protocolFee == 0">0</span>
							</div>
							<ul v-if="takerFee > 0 || protocolFee > 0">
								<li v-if="takerFee > 0">
									{{ $t('common.noun.takerFee') }}:
									{{ formatAmountNumber(takerFee) }}
									<span v-if="takerFeeAssetInfo">{{ takerFeeAssetInfo.symbol }}</span>
								</li>
								<li v-if="protocolFee > 0">
									{{ $t('common.noun.protocolFee') }}:
									{{ formatAmountNumber(protocolFee) }} ETH
								</li>
							</ul>

						</v-col>

					</v-row>

				</div>
				<!-- ==================================== End isTaker ===================================== -->


				<!-- ================================= Begin isForwarderBuying ================================== -->
				<div v-if="isForwarderBuying">

					<v-row dense>

						<!-- taker token -->
						<v-col class="nowrap">
							<ETHToken></ETHToken>
							<div class="order-amount-wrapper">{{ $t('common.verb.haveSent')}}: <AmountNumber :value="takerTokenAmount" /></div>
						</v-col>

						<!-- maker token -->
						<v-col class="nowrap">
							<ERC20Token :symbol="makerAssetInfo.symbol"
								:name="makerAssetInfo.name"
								:address="makerAssetInfo.address"
								:decimals="makerAssetInfo.decimals"
								:tokenurl="tokenurl" />
							<div class="order-amount-wrapper">{{ $t('common.verb.haveReceived')}}:  <AmountNumber :value="makerTokenAmount" /></div>
						</v-col>
					</v-row>

					<v-row dense>

						<!-- price taker per maker -->
						<v-col class="nowrap">
							1 ETH =
							<strong>{{ formatAmountNumber(priceTakerPerMaker) }}</strong>
							{{ makerAssetInfo.symbol }}
						</v-col>

						<!-- price maker per taker -->
						<v-col class="nowrap">
							1 {{ makerAssetInfo.symbol }} =
							<strong>{{ formatAmountNumber(priceMakerPerTaker) }}</strong>
							ETH
						</v-col>

					</v-row>

					<v-row dense>

						<!-- maker -->
						<v-col class="nowrap">
							<strong>{{ $t('common.noun.maker') }}</strong>: <UserAddress :address="trade.makerAddress" :myaddress="network.userAccount" :accounturl="networkConfig.accountURL" markself></UserAddress>
						</v-col>

						<!-- buyer -->
						<v-col class="nowrap">
							<strong>{{ $t('common.noun.buyer') }}</strong>: <UserAddress :address="trade.txFromAddress" :myaddress="network.userAccount" :accounturl="networkConfig.accountURL" markself></UserAddress>
						</v-col>
					</v-row>

					<v-row dense>

						<v-col class="nowrap">

							<!-- taker fee -->
							<div>
								<strong>{{ $t('compTradeSummary.exChangeFeeYouPaid') }}</strong>:
								<span v-if="takerFee == 0 && protocolFee == 0">0</span>
							</div>
							<ul v-if="takerFee > 0 || protocolFee > 0">
								<li v-if="takerFee > 0">
									{{ $t('common.noun.takerFee') }}:
									{{ formatAmountNumber(takerFee) }}
									<span v-if="takerFeeAssetInfo">{{ takerFeeAssetInfo.symbol }}</span>
								</li>
								<li v-if="protocolFee > 0">
									{{ $t('common.noun.protocolFee') }}:
									{{ formatAmountNumber(protocolFee) }} ETH
								</li>
							</ul>

						</v-col>

					</v-row>

				</div>
				<!-- ================================= End isForwarderBuying ================================== -->

			</div>

			<div v-else>

				<strong>{{ $t('common.noun.maker') }}</strong>: <UserAddress :address="trade.makerAddress" :myaddress="myaddress" :accounturl="accounturl"></UserAddress> <br />
				<strong>{{ $t('common.noun.taker') }}</strong>:  <UserAddress :address="trade.takerAddress" :myaddress="myaddress" :accounturl="accounturl"></UserAddress> <br />

				<strong>{{ $t('common.noun.block') }}</strong>: {{ trade.blockNumber}} <br />
				<strong>{{ $t('common.noun.makerToken') }}</strong>: {{ trade.makerAssetAddress }} <br />
				<strong>{{ $t('common.noun.makerTokenAmount') }}</strong>: {{ trade.makerAssetAddressAmount }} <br />
				<strong>{{ $t('common.noun.takerToken') }}</strong>: {{ trade.takerAssetAddress }} <br />
				<strong>{{ $t('common.noun.takerTokenAmount') }}</strong>: {{ trade.takerAssetAddressAmount }} <br />

			</div>

			<div class="text-right mt-2">
				<v-btn color="secondary" small :href="txurl + trade.transactionHash" target="_blank">
					{{ $t('compTradeSummary.btnViewDetails') }}
					<v-icon small class="ml-2">mdi-open-in-new</v-icon>
				</v-btn>
			</div>

		</div>

	</div><!-- trade summary -->

</div>

</template>

<script>
import { BigNumber } from '@0x/utils'
import { Web3Wrapper } from '@0x/web3-wrapper'
import { mapActions, mapGetters, mapState } from 'vuex'
import Preloader from "@/components/Preloader"
import UserAddress from "@/components/UserAddress"
import AmountNumber from "@/components/AmountNumber"
import ERC20Token from "@/components/ERC20Token"
import ETHToken from "@/components/ETHToken"
import { showDateTime, formatAmountNumber } from '@/utils/utils'

export default {
	name: 'TradeSummary',
	components: {
		Preloader,
		UserAddress,
		AmountNumber,
		ERC20Token,
		ETHToken,
	},
	props: {
		trade: {
			type: Object,
			required: true
		},
		loadtimestamp: { type: Boolean, default: false },
		loadtokens: { type: Boolean, default: false }
	},
	data () {
		return {
			initializationDone: false,
			timeStamp: null,
			makerAssetInfo: null,
			takerAssetInfo: null,
			makerFeeAssetInfo: null,
			takerFeeAssetInfo: null,
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			web3Wrapper: 'getWeb3Wrapper',
			providerEngine: 'getProviderEngine',
			contractWrappers: 'getContractWrappers',
			contractAddresses: 'getContractAddresses',
			networkConfig: 'getNetworkConfig',
		}),
		// initializationDone: function () {
		// 	const networkLoaded = this.network.id
		// 	const makerTokenLoaded = this.loadtokens ? this.makerAssetInfo : false
		// 	const takerTokenLoaded = this.loadtokens ? this.takerAssetInfo : false
		// 	const timestampLoaded = this.loadtimestamp ? this.timeStamp : false
		// 	return (networkLoaded && makerTokenLoaded && takerTokenLoaded && timestampLoaded)
		// },
		isMaker: function () {
			return this.trade.makerAddress === this.network.userAccount
		},
		isTaker: function () {
			return this.trade.takerAddress === this.network.userAccount
		},
		isForwarderBuying: function () {
			return this.trade.txFromAddress === this.network.userAccount &&
				this.trade.takerIsForwardingContract === true &&
				this.trade.takerAssetAddress === this.tokenInfo.WETHToken.address
		},
		makerTokenAmount: function () {
			if (this.makerAssetInfo) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.makerAssetFilledAmount), this.makerAssetInfo.decimals).toNumber()
			}
			else {
				return null
			}
		},
		takerTokenAmount: function () {
			if (this.takerAssetInfo) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.takerAssetFilledAmount), this.takerAssetInfo.decimals).toNumber()
			}
			else {
				return null
			}
		},
		makerFeeAmount: function () {
			if (this.makerFeeAssetInfo) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.makerFeePaid), this.makerFeeAssetInfo.decimals).toNumber()
			}
			else {
				return null
			}
		},
		takerFeeAmount: function () {
			if (this.takerFeeAssetInfo) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.takerFeePaid), this.takerFeeAssetInfo.decimals).toNumber()
			}
			else {
				return null
			}
		},
		protocolFeeAmount: function () {
			if (this.takerFeeAssetInfo) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.protocolFeePaid), this.tokenInfo.WETHToken.decimals).toNumber()
			}
			else {
				return null
			}
		},
		priceMakerPerTaker: function () {
			if (this.makerTokenAmount && this.takerTokenAmount) {
				return this.takerTokenAmount / this.makerTokenAmount
			}
			else {
				return null
			}
		},
		priceTakerPerMaker: function () {
			if (this.makerTokenAmount && this.takerTokenAmount) {
				return this.makerTokenAmount / this.takerTokenAmount
			}
			else {
				return null
			}
		},
		makerFee: function () {
			if (this.makerFeeAssetInfo && this.trade.makerFeePaid > 0) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.makerFeePaid), this.makerFeeAssetInfo.decimals).toNumber()
			}
			else {
				return 0
			}
		},
		takerFee: function () {
			if (this.takerFeeAssetInfo && this.trade.takerFeePaid > 0) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.takerFeePaid), this.takerFeeAssetInfo.decimals).toNumber()
			}
			else {
				return 0
			}
		},
		protocolFee: function () {
			return Web3Wrapper.toUnitAmount(new BigNumber(this.trade.protocolFeePaid), this.tokenInfo.WETHToken.decimals).toNumber()
		},
		myaddress: function () {
			return this.network.userAccount
		},
		txurl: function () {
			return this.networkConfig.txURL
		},
		accounturl: function () {
			return this.networkConfig.accountURL
		},
		tokenurl: function () {
			return this.networkConfig.tokenURL
		}
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'getTokenInfoByAssetData']),
		showDateTime: showDateTime,
		formatAmountNumber: formatAmountNumber,
		async init() {
			// console.log('begin load trade')
			this.initializationDone = false
			await this.loadNetwork()
			const tasks = []
			if (this.loadtimestamp) {
				// await this.loadTimeStamp()
				tasks.push(this.loadTimeStamp())
			}
			if (this.loadtokens) {
				// await this.loadMakerToken()
				// await this.loadTakerToken()
				// await this.loadMakerFeeToken()
				// await this.loadTakerFeeToken()
				tasks.push(this.loadMakerToken())
				tasks.push(this.loadTakerToken())
				tasks.push(this.loadMakerFeeToken())
				tasks.push(this.loadTakerFeeToken())
			}
			await Promise.all(tasks)
			// console.log('end log trade')
			this.initializationDone = true
			// console.log(this.trade)
		},
		async loadTimeStamp() {
			if (this.trade.blockTimeStamp) {
				this.timeStamp = showDateTime(this.trade.blockTimeStamp * 1000)
				return
			}
			else {
				if (!this.trade.blockNumber) {
					return
				}
				const block = await this.web3Wrapper.getBlockIfExistsAsync(this.trade.blockNumber)
				if (block) {
					// console.log(block.timestamp)
					this.timeStamp = showDateTime(block.timestamp * 1000)
					// console.log(this.timeStamp)
				}
			}
		},
		async loadMakerToken() {
			if (!this.trade.makerAssetData) {
				return
			}
			this.makerAssetInfo = await this.getTokenInfoByAssetData(this.trade.makerAssetData)
		},
		async loadTakerToken() {
			if (!this.trade.takerAssetData) {
				return
			}
			this.takerAssetInfo = await this.getTokenInfoByAssetData(this.trade.takerAssetData)
		},
		async loadMakerFeeToken() {
			if (!this.trade.makerFeePaid || parseInt(this.trade.makerFeePaid) == 0 || !this.trade.makerFeeAssetData.length > 2) {
				return
			}
			this.makerFeeAssetInfo = await this.getTokenInfoByAssetData(this.trade.makerFeeAssetData)
		},
		async loadTakerFeeToken() {
			if (!this.trade.takerFeePaid || parseInt(this.trade.takerFeePaid) == 0 || !this.trade.takerFeeAssetData.length > 2) {
				return
			}
			this.takerFeeAssetInfo = await this.getTokenInfoByAssetData(this.trade.takerFeeAssetData)
		},
	},
	created () {
		this.init()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.trade-summary {
	font-size: 14px;
}
.trade-section {
	/*min-width: 500px;*/
	max-width: 600px;
	margin: 15px auto;
	padding: 15px 25px;
	border: 1px solid #dedede;
	background-color: #f9f9f9;
}
.theme--dark .trade-section {
	background-color: #353535;
	color: #EDEDED;
}
/*.order-amount-wrapper {
	display: inline-block;
	background-color: #FFF;
	padding: 3px 8px;
	border-top: 1px solid #CCC;
	border-right: 1px solid #CCC;
	border-bottom: 1px solid #CCC;
	margin-left: -8px;
}
.dark-app .trade-amount-wrapper {
	background-color: #373737;
	border-top: 1px solid #747474;
	border-right: 1px solid #747474;
	border-bottom: 1px solid #747474;
}*/
.trade-price-wrapper {
	display: inline-block;
	background-color: #FFF;
	padding: 0px 8px;
	border: 1px solid #CCC;
}
.dark-app .trade-price-wrapper {
	background-color: #373737;
	border: 1px solid #747474;
}
</style>
